var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:(_vm.NAME_PRE + "-icon"),attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('use',{attrs:{"xlink:href":("#" + _vm.NAME_PRE + "-icon-" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }